import { render, staticRenderFns } from "./CheckpointStartScene.vue?vue&type=template&id=2c321bb8&scoped=true&"
import script from "./CheckpointStartScene.vue?vue&type=script&lang=js&"
export * from "./CheckpointStartScene.vue?vue&type=script&lang=js&"
import style0 from "./CheckpointStartScene.vue?vue&type=style&index=0&id=2c321bb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c321bb8",
  null
  
)

export default component.exports